/* MORFIS 03.10.2026: надписите на бутона идват от window.lbStrings (по език), с BG резерва */
function LBT(k, d){ try { return (window.lbStrings && window.lbStrings[k]) || d; } catch(e){ return d; } }
/* ============================================================
   Love Biotica — Product Page JS
   - Image gallery (thumbnail swap)
   - Variant picker
   - Subscription toggle
   - Qty stepper
   - Add to cart — integrates with theme cart-drawer (Dawn-pattern)
   - FAQ accordion
   - Sticky mobile CTA (IntersectionObserver, not visible until main ATC scrolled past)
   ============================================================ */
(function () {
  var cfg = window.LB_PRODUCT || { moneyFormat: '€{{amount_no_decimals}}', productHandle: '', currentVariantId: 0 };

  var form        = document.getElementById('lbProductForm');
  if (!form) return;

  var variantIdEl = document.getElementById('lbVariantId');
  var qtyValEl    = document.getElementById('qtyVal');
  var qtyInput    = document.getElementById('lbQty');
  var priceEl     = document.getElementById('lbPrice');
  var addBtn      = document.getElementById('lbAddBtn');
  var mcPrice     = document.getElementById('mcPrice');
  var mobileBtn   = document.querySelector('[data-add-to-cart-mobile]');
  var galleryMain = document.getElementById('galleryMain');
  var dataTag     = document.getElementById('lbProductData');

  var variants = [];
  if (dataTag) { try { variants = JSON.parse(dataTag.textContent); } catch (e) { variants = []; } }

  function formatMoney(cents) {
    if (typeof cents !== 'number') cents = parseInt(cents, 10) || 0;
    var amt = cents / 100;
    var fmt = cfg.moneyFormat || '€{{amount_no_decimals}}';
    var amountStr;
    if (fmt.indexOf('{{amount_no_decimals}}') !== -1) {
      amountStr = Math.round(amt).toString();
      return fmt.replace('{{amount_no_decimals}}', amountStr);
    }
    if (fmt.indexOf('{{amount}}') !== -1) {
      amountStr = amt.toFixed(2);
      return fmt.replace('{{amount}}', amountStr);
    }
    if (fmt.indexOf('{{amount_with_comma_separator}}') !== -1) {
      amountStr = amt.toFixed(2).replace('.', ',');
      return fmt.replace('{{amount_with_comma_separator}}', amountStr);
    }
    return fmt + amt.toFixed(2);
  }

  // ---- Image gallery ----
  document.querySelectorAll('.thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      var src = t.getAttribute('data-src');
      if (galleryMain && src) galleryMain.src = src;
      document.querySelectorAll('.thumb').forEach(function (x) { x.classList.remove('active'); });
      t.classList.add('active');
    });
  });

  // ---- Variant picker ----
  function getSelectedOptions() {
    var opts = [];
    document.querySelectorAll('.pills').forEach(function (group) {
      var checked = group.querySelector('input:checked');
      if (checked) opts.push(checked.value);
    });
    return opts;
  }

  function findVariantForOptions(opts) {
    if (!variants.length || !opts.length) return variants[0] || null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var match = true;
      for (var j = 0; j < opts.length; j++) {
        var ov = v['option' + (j + 1)];
        if (ov !== opts[j]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  function syncVariant() {
    var opts = getSelectedOptions();
    var v = findVariantForOptions(opts);
    if (!v) {
      if (addBtn) { addBtn.disabled = true; addBtn.textContent = LBT('unavailable', 'Недостъпно'); }
      return;
    }
    if (variantIdEl) variantIdEl.value = v.id;
    syncPrice(v);
  }

  function syncPrice(variant) {
    if (!variant) {
      variant = variants.find(function (vv) { return String(vv.id) === String(variantIdEl && variantIdEl.value); });
    }
    if (!variant) return;

    var qty = parseInt(qtyInput && qtyInput.value, 10) || 1;
    var subRadio = document.querySelector('input[name="selling_plan"]:checked');
    var subDiscount = 0;

    if (subRadio && subRadio.value) {
      var alloc = (variant.selling_plan_allocations || []).find(function (a) {
        return String(a.selling_plan_id) === String(subRadio.value);
      });
      if (alloc && typeof alloc.per_delivery_price === 'number') {
        subDiscount = variant.price - alloc.per_delivery_price;
      } else {
        subDiscount = Math.round(variant.price * 0.10);
      }
    }

    var unit  = variant.price - subDiscount;
    var total = unit * qty;
    var label = (addBtn && addBtn.dataset.defaultLabel) || 'Добави ритуала';

    var priceLine = document.getElementById('lbPriceLine');

    if (priceEl)  priceEl.textContent = formatMoney(unit);
    if (mcPrice)  mcPrice.textContent = formatMoney(unit);
    if (priceLine) priceLine.textContent = formatMoney(total);

    if (addBtn && addBtn.dataset.state !== 'added' && addBtn.dataset.state !== 'loading') {
      if (variant.available) {
        addBtn.disabled = false;
        addBtn.textContent = priceLine ? label : (label + ' — ' + formatMoney(total));
      } else {
        addBtn.disabled = true;
        addBtn.textContent = LBT('soldout', 'Изчерпано');
      }
    }
    if (mobileBtn && mobileBtn.dataset.state !== 'added' && mobileBtn.dataset.state !== 'loading') {
      mobileBtn.disabled = !variant.available;
      mobileBtn.textContent = variant.available ? (label + ' — ' + formatMoney(total)) : LBT('soldout', 'Изчерпано');
    }
  }

  document.querySelectorAll('.pills input, input[name="selling_plan"]').forEach(function (i) {
    i.addEventListener('change', syncVariant);
  });

  // ---- Quantity ----
  document.querySelectorAll('[data-qty]').forEach(function (b) {
    b.addEventListener('click', function () {
      var step = parseInt(b.getAttribute('data-qty'), 10);
      var cur = parseInt(qtyInput.value, 10) || 1;
      var next = Math.max(1, Math.min(9, cur + step));
      qtyInput.value = next;
      if (qtyValEl) qtyValEl.textContent = String(next);
      syncPrice();
    });
  });

  // ---- Add to cart (Dawn-pattern: sections-rendering API + cart-drawer.renderContents) ----
  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function publishCart(name, payload) {
    if (window.publish && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS[name]) {
      try { window.publish(window.PUB_SUB_EVENTS[name], payload); } catch (e) {}
    }
  }

  function addToCart(triggerBtn) {
    if (triggerBtn && triggerBtn.dataset.state === 'loading') return; // dup-submit guard

    var variantId = variantIdEl && variantIdEl.value;
    if (!variantId) return;
    var qty = parseInt(qtyInput.value, 10) || 1;
    var subRadio = document.querySelector('input[name="selling_plan"]:checked');

    var cartDrawer = getCartDrawer();
    var sections = [];
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      try {
        sections = cartDrawer.getSectionsToRender().map(function (s) { return s.id; });
      } catch (e) { sections = []; }
    }

    var item = { id: parseInt(variantId, 10), quantity: qty };
    if (subRadio && subRadio.value) item.selling_plan = parseInt(subRadio.value, 10);

    var body = { items: [item] };
    if (sections.length) {
      body.sections = sections.join(',');
      body.sections_url = window.location.pathname;
    }

    // MORFIS 02.11.2026: системата + подаръкът (четката) в една заявка (window.LB_GIFT идва от snippets/lb-gift-config.liquid).
    // Ако подаръкът вече е в количката, не го добавяме втори път; ако е свършил междувременно, системата се добавя сама.
    var lbGift = window.LB_GIFT;
    var withGift = !!(lbGift && lbGift.on && lbGift.gift && !lbGift.inCart && String(variantId) === String(lbGift.system));
    if (withGift) body.items.push({ id: lbGift.gift, quantity: 1 });

    function postAdd() {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/json',
          'Accept': 'application/javascript'
        },
        body: JSON.stringify(body)
      }).then(function (res) {
        return res.json().then(function (parsed) { return { ok: res.ok, parsed: parsed }; });
      });
    }

    if (triggerBtn) {
      triggerBtn.disabled = true;
      triggerBtn.dataset.state = 'loading';
      triggerBtn.dataset.prevLabel = triggerBtn.textContent;
      triggerBtn.textContent = LBT('adding', 'Добавям…');
    }

    postAdd()
      .then(function (result) {
        if (withGift && (!result.ok || result.parsed.status)) {
          withGift = false;
          body.items = [item];
          return postAdd();
        }
        return result;
      })
      .then(function (result) {
        var parsed = result.parsed;

        // Error shape: { status, message, description, errors }
        if (!result.ok || parsed.status) {
          var msg = parsed.description || parsed.message || 'Try again';
          if (triggerBtn) {
            triggerBtn.dataset.state = '';
            triggerBtn.disabled = false;
            triggerBtn.textContent = msg;
          }
          publishCart('cartError', { source: 'lb-product-form', productVariantId: variantId, errors: parsed.errors || msg });
          setTimeout(syncPrice, 2500);
          return;
        }

        // Success
        if (triggerBtn) {
          triggerBtn.dataset.state = 'added';
          triggerBtn.textContent = LBT('added', 'Добавено ✓');
        }

        var drawer = getCartDrawer();
        if (drawer && parsed.sections && typeof drawer.renderContents === 'function') {
          // Dawn API: renders cart-drawer + cart-icon-bubble HTML and opens the drawer
          drawer.renderContents(parsed);
          drawer.classList.remove('is-empty'); // first add from empty cart leaves stale class
        } else {
          // Fallback: refresh count + open drawer manually
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            document.querySelectorAll('.hdr-cart-count-numb, .hdr-cart-count, [data-cart-count]').forEach(function (el) {
              el.textContent = String(cart.item_count);
            });
            var d = getCartDrawer();
            if (d && typeof d.open === 'function') { try { d.open(triggerBtn); } catch (e) {} }
          });
        }

        publishCart('cartUpdate', { source: 'lb-product-form', productVariantId: variantId, cartData: parsed });

        setTimeout(function () {
          if (triggerBtn) {
            triggerBtn.disabled = false;
            triggerBtn.dataset.state = '';
            syncPrice();
          }
        }, 1800);
      })
      .catch(function (err) {
        if (triggerBtn) {
          triggerBtn.disabled = false;
          triggerBtn.dataset.state = '';
          triggerBtn.textContent = LBT('retry', 'Опитай пак');
          setTimeout(syncPrice, 2200);
        }
        publishCart('cartError', { source: 'lb-product-form', productVariantId: variantId, errors: err && err.message });
        if (window.console) console.error('LB ATC failed:', err);
      });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    addToCart(addBtn);
  });

  if (mobileBtn) {
    mobileBtn.addEventListener('click', function (e) {
      e.preventDefault();
      addToCart(mobileBtn);
    });
  }

  // ---- Sticky mobile bar: only show after main ATC scrolls out of view ----
  (function () {
    var stickyBar = document.querySelector('.mobile-cta');
    var anchor = document.querySelector('.qty-add') || document.getElementById('lbAddBtn');
    if (!stickyBar || !anchor || !('IntersectionObserver' in window)) return;
    stickyBar.dataset.visible = 'false';
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var passed = entry.boundingClientRect.bottom < 0;
        stickyBar.dataset.visible = passed ? 'true' : 'false';
      });
    }, { threshold: 0, rootMargin: '0px 0px 0px 0px' });
    io.observe(anchor);
  })();

  // ---- FAQ accordion (event delegation: this script loads from inside main-product-lb section,
  //      which is rendered before lb-faq section. querySelectorAll('.acc-q') at script-load
  //      returns empty. Delegation on document survives that ordering issue.) ----
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var q = e.target.closest('.acc-q');
    if (!q) return;
    var acc = q.parentElement;
    var panel = q.nextElementSibling;
    if (!acc || !panel || !panel.classList.contains('acc-a')) return;
    var isOpen = acc.classList.contains('open');
    if (isOpen) {
      acc.classList.remove('open');
      q.setAttribute('aria-expanded', 'false');
      panel.style.maxHeight = '0px';
    } else {
      acc.classList.add('open');
      q.setAttribute('aria-expanded', 'true');
      panel.style.maxHeight = panel.scrollHeight + 'px';
    }
  });

  // Recompute open-panel heights on resize (FAQ text reflows)
  window.addEventListener('resize', function () {
    document.querySelectorAll('.acc.open .acc-a').forEach(function (p) {
      p.style.maxHeight = p.scrollHeight + 'px';
    });
  });

  // ---- Smooth anchor scroll (also delegated for same DOM-ordering reason) ----
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var a = e.target.closest('a[href^="#"]');
    if (!a) return;
    var id = a.getAttribute('href');
    if (!id || id.length <= 1) return;
    var t = document.querySelector(id);
    if (!t) return;
    e.preventDefault();
    window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' });
  });

  // ---- ATC backup via delegation (in case direct form/button listeners ever miss) ----
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var btn = e.target.closest('#lbAddBtn, [data-add-to-cart], [data-add-to-cart-mobile]');
    if (!btn) return;
    // Avoid double-handle: if direct listener already disabled the button this round, skip
    if (btn.dataset.state === 'loading' || btn.dataset.state === 'added') return;
    // Only trigger if it's outside a form (mobile bar) or the form submit listener somehow didn't fire
    if (btn.id === 'lbAddBtn') return; // form submit handles it
    e.preventDefault();
    addToCart(btn);
  });

  syncPrice();
})();
